import contacts from 'src/i18n/fr/fields/contacts';
import contact_groups from 'src/i18n/fr/fields/contact_groups';
import invoices from 'src/i18n/fr/fields/invoices';
import payments from 'src/i18n/fr/fields/payments';
import recurrings from 'src/i18n/fr/fields/recurrings';
import tax_receipts from 'src/i18n/fr/fields/tax_receipts';
import events from 'src/i18n/fr/fields/events';
import event_transactions from 'src/i18n/en/fields/fundraising_transaction';
import ambassadors from 'src/i18n/fr/fields/ambassadors';
import payment_gateways from 'src/i18n/fr/fields/payment_gateways';
import event_tickets from 'src/i18n/fr/fields/event_tickets';
import sellers from 'src/i18n/fr/fields/sellers';
import products from 'src/i18n/fr/fields/products';
import ticket_contacts from 'src/i18n/fr/fields/ticket_contacts';

const fields = {
  ambassadors,
  contacts,
  contact_groups,
  events,
  event_transactions,
  invoices,
  payments,
  recurrings,
  tax_receipts,
  payment_gateways,
  event_tickets,
  sellers,
  products,
  ticket_contacts,
};

export default fields;
//
